<template>
  <b-navbar toggleable="md" type="dark" variant="primary" class="navbar-gekko content-wrap" :class="routeClass" :style="'background-color:' + brandingColor + '!important;'">
    <div class="navbar-header">
      <a :href="Urls['gekko_dashboard']()" @click.prevent="redirectLogoRouter(Urls['gekko_dashboard']())" class="navbar-brand">
        <img v-if="hasAccountantLogo" :src="currentCompany.accountant_branding.logo" class="img-circle">
        <GkLogo v-else :full="false" :fill="'white'" />
      </a>
      <MainCompanyPicker :is-accountant="isAccountant" />
      <b-dropdown 
        left
        class="ui-dashboard-menu-dropdown gk-animated-dropdown gk-animated-notifications" 
        :class="{ 'has-notifications': hasNotifications }"
        toggle-class="gk-animated-dropdown-toggle" 
        :style="cssVars"
        ref="navbar-notifications-main-dropdown"
      >
        <template #button-content>
          <font-awesome-icon icon="fa-regular fa-bell" class="mr-0" />
        </template>
        <b-dropdown-form>
          <NotificationsWidget :main-top="true" :widget="{ config: { status: 'unseen' } }" />
        </b-dropdown-form>
      </b-dropdown>
    </div>

    <b-navbar-toggle target="nav-collapse">
      <font-awesome-icon icon="fa-solid fa-bars" />
    </b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ml-auto">

        <!-- Dashboard mobile -->
        <b-nav-item :href="Urls['gekko_dashboard']()" data-analytics-click="costs home" 
                    class="d-md-none" :class="{ active: currentPage.includes('dashboard') }">
          <font-awesome-icon icon="fa-solid fa-gauge-high" />
          <span v-translate>Dashboard</span>
        </b-nav-item>

      
        <!-- Dashboard desktop NEW -->
        <b-nav-item-dropdown 
          data-analytics-click="dashboard" no-caret menu-class="bg-inherit" 
          :style="'background-color:' + brandingColor + '!important;'"
          ref="nav-dd-dashb"
          class="d-none d-md-block bg-primary"
          :class="{ active: (currentPage.includes('dashboard') || currentPage.includes('reports')) }"
          @mouseover.native="showDropdownMenu('nav-dd-dashb')"
          @mouseleave.native="hideDropdownMenu('nav-dd-dashb')"
        >
          <template #button-content>
            <a :href="Urls['gekko_dashboard']()" @click="redirectRouter(Urls['gekko_dashboard']())">
              <font-awesome-icon icon="fa-solid fa-home" />
              <span v-translate>Dashboard</span>
            </a>
          </template>

        <!-- Dashboard desktop -->
        <!-- <b-nav-item-dropdown 
          data-analytics-click="dashboard" no-caret menu-class="bg-inherit"
          :style="'background-color:' + brandingColor + '!important;'"
          ref="nav-dd-dashb"
          class="d-none d-md-block bg-primary"
          :class="{ active: (currentPage.includes('dashboard') || currentPage.includes('reports')) }"
          @mouseover.native="showDropdownMenu('nav-dd-dashb')"
          @mouseleave.native="hideDropdownMenu('nav-dd-dashb')"
        >
          <template #button-content>
            <a :href="Urls['gekko_dashboard']()" @click="redirect(Urls['gekko_dashboard']())">
              <font-awesome-icon icon="fa-solid fa-home" />
              <span v-translate>Dashboard</span>
            </a>
          </template> -->

          <!-- Dashboard -> Reports -->
          <b-dropdown-item v-if="rights.financial_details" :to="Urls['reports:report_list']()" data-analytics-click="report page">
            <font-awesome-icon icon="fa-solid fa-chart-column" />
            <span v-translate>Reports</span>
          </b-dropdown-item>

          <!-- Dashboard -> Documents -->
          <b-dropdown-item :to="Urls['documents:documents_home']()" data-analytics-click="documents home">
            <font-awesome-icon icon="fa-solid fa-briefcase" />
            <span v-translate>Documents</span>
          </b-dropdown-item>

          <b-dropdown-item :to="Urls['accounts_files']()" data-analytics-click="downloads page">
            <font-awesome-icon icon="fa-solid fa-download" />
            <span v-translate>Downloads</span>
          </b-dropdown-item>
        </b-nav-item-dropdown>

        <!-- Invoices mobile -->
        <b-nav-item v-if="rights.invoices" :to="Urls['invoices_display_invoices']()"
                    data-analytics-click="invoices home"
                    class="d-md-none" :class="{ active: currentPage.includes('invoices') }">
          <font-awesome-icon icon="fa-solid fa-file-lines" />
          <span v-translate>Invoices</span>
        </b-nav-item>

        <!-- Invoices desktop -->
        <b-nav-item-dropdown v-if="rights.invoices" data-analytics-click="invoices home" no-caret
                              menu-class="bg-inherit" ref="nav-dd-invoi" :style="'background-color:' + brandingColor + '!important;'"
                              class="d-none d-md-block bg-primary"
                              :class="{ active: (currentPage.includes('invoices') || currentPage.includes('quotations'))}"
                              @mouseover.native="showDropdownMenu('nav-dd-invoi')"
                              @mouseleave.native="hideDropdownMenu('nav-dd-invoi')">
          <template #button-content>
            <a :to="Urls['invoices_display_invoices']()" @click="redirectRouter(Urls['invoices_display_invoices']())">
              <font-awesome-icon icon="fa-solid fa-file-lines" />
              <span v-translate>Invoices</span>
            </a>
          </template>

          <!-- Invoices -> Quotations -->
          <b-dropdown-item :to="Urls['quotations:home']()" data-analytics-click="quotations home">
            <font-awesome-icon icon="fa-regular fa-file-lines" />
            <span v-translate>Quotations</span>
          </b-dropdown-item>
        </b-nav-item-dropdown>

        <!-- Quotations mobile -->
        <b-nav-item v-if="rights.invoices" :to="Urls['quotations:home']()" data-analytics-click="quotations home" 
                    class="d-md-none" :class="{ active: currentPage.includes('quotations') }">
          <font-awesome-icon icon="fa-regular fa-file-lines" />
          <span v-translate>Quotations</span>
        </b-nav-item>

        <!-- Costs -->
        <b-nav-item v-if="rights.costs" :to="Urls['costs_display_costs']()" data-analytics-click="costs home" 
                    :class="{ active: currentPage.includes('costs') }">
          <font-awesome-icon icon="fa-solid fa-cart-shopping" />
          <span v-translate>Costs</span>
        </b-nav-item>

        <!-- Hours -->
        <b-nav-item v-if="rights.hours" :to="Urls['hours_home']()" data-analytics-click="hours home" 
                    :class="{ active: currentPage.includes('hours') }">
          <font-awesome-icon icon="fa-regular fa-clock" />
          <span v-translate>Hours</span>
        </b-nav-item>

        <!-- Trips -->
        <b-nav-item v-if="rights.trips" :to="Urls['trips_home']()" data-analytics-click="trips home" 
                    :class="{ active: currentPage.includes('trips') }">
          <font-awesome-icon icon="fa-solid fa-car" />
          <span v-translate>Trips</span>
        </b-nav-item>

        <!-- Bank -->
       <b-nav-item v-if="rights.banks" :to="{ name: 'Bank' }" data-analytics-click="banks"
                    :class="{ active: currentPage.includes('bank') }">
          <font-awesome-icon icon="fa-solid fa-building-columns" />
          <span v-translate>Bank</span>
        </b-nav-item>

        <!-- Contacts -->
        <b-nav-item v-if="rights.change_customers" :to="Urls['addressbook_display']()"
                    data-analytics-click="addressbook home"
                    :class="{ active: currentPage.includes('addressbook') }">
          <font-awesome-icon icon="fa-solid fa-heart" />
          <span v-translate>Contacts</span>
        </b-nav-item>

        <!-- Reports mobile -->
        <b-nav-item v-if="rights.financial_details" :to="Urls['reports:report_list']()"
                    data-analytics-click="report home" class="d-md-none"
                    :class="{ active: currentPage.includes('reports') }">
          <font-awesome-icon icon="fa-solid fa-chart-column" />
          <span v-translate>Reports</span>
        </b-nav-item>
        <!-- Ai Assistant -->

        <b-nav-item
          data-analytics-click="chatbot"
          class="d-md-flex nav-item text-yellow"
          @click="$emit('toggleChatbot')">
            <font-awesome-icon icon="fa-solid fa-message-bot" class="text-yellow" />
            <span v-translate class="text-yellow">GekkoBot</span>
        </b-nav-item>

      </b-navbar-nav>
    </b-collapse>
        
  </b-navbar>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import UserRightsService from "@/store/services/userrights.service.js";
import MainCompanyPicker from "@/components/MainCompanyPicker";
import NotificationsWidget from "@/components/dashboard/widgets/NotificationsWidget"
import GkLogo from "@/components/ui/GkLogo.vue";

export default {
  name: "GekkoMenu",
  components: { MainCompanyPicker, NotificationsWidget, GkLogo },
  computed: {
    currentPage () {
      return this.$route.path
    },
    ...mapGetters({ 
      hasNotifications: "notifications/getNotificationNewCount",
      currentCompany: 'main/getCurrentCompany',
      currentUser: 'main/getCurrentUser',
      currentUserRights: 'main/getCurrentRights',
      currentUserAccessRights: 'main/getCurrentAccessRights'
    }),
    cssVars() {
      return {
        '--not-count': JSON.stringify(this.hasNotifications.toString())
      }
    },
    brandingColor() {
      if (this.currentCompany.accountant_branding)
        return this.currentCompany.accountant_branding.color;
      else
        return "#22AC8A"; // $colorBrand
    },
    hasAccountantLogo () {
      return this.currentCompany.accountant_branding && this.currentCompany.accountant_branding.logo
    },
    isAccountant () {
      return this.accessRights.user_is_of_connected_accountant
    },
    rights () {
      return this.currentUserRights
    },
    accessRights () {
      return this.currentUserAccessRights
    },
    routeClass () {
      return (this.$route && this.$route.name) ? this.$route.name.toLowerCase() : ''
    }
  },
  methods: {
    ...mapActions({ 
      switchToVisitingCompany: 'main/switchToVisitingCompany'
    }),
    showDropdownMenu (element) {
      this.$refs[element].show()
    },
    hideDropdownMenu (element) {
      this.$refs[element].hide()
    },
    redirect (url) {//TODO: alejandro, remove if it is no longer necessary. after i removed it for invoices. i left it in case you still want it
      window.location.href = url
    },
    redirectLogoRouter (url) {
      if (this.isAccountant) {
        // TODO update to $router when accountant portal vue migration is complete
        this.switchToVisitingCompany(this.currentUser.default_company)
      } else {
        this.redirectRouter(url)
      }
    },
    redirectRouter (url) {
      if (url === this.$router.currentRoute.fullPath) {
        this.$router.go(url)
      } else {
        this.$router.push(url)
      }
    }
  }
};
</script>

<style lang="scss">
.navbar.navbar-gekko {
  width: 100%;
  height: $topbarHeight;
  min-height: $topbarHeight;
  padding: 0 1rem;
  padding-left: 15px;
  padding-right: 0;
  transition: background-color 0.2s ease;
  .navbar-header {
    display: flex;
    height: 100%;
    max-width: 30%;
  }
  @media(max-width: '767px') {
    height: auto;
    .navbar-header {
      height: auto;
      max-width: calc(100% - 50px);
      width: 100%;
      .gk-animated-dropdown {
        margin-left: auto;
      }
    }
  }
  .navbar-brand {
    padding: 7px 0px;
    margin-right: 10px;
    height: 50px;
    display: block;
    flex: none;
    img {
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }
    svg {
      height: 100%;
      width: auto;
    }
  }
  .navbar-toggler {
    margin-right: 15px;
    margin-top: 8px;
    margin-bottom: 8px;
    border: none;
    font-size: 30px;
    line-height: normal;
    padding: 0;
    color: white;
    cursor: pointer;
  }
  .navbar-collapse {
    margin-left: -10px;
  }
  .navbar-collapse.show, .navbar-collapse.collapsing {
    box-shadow: inset 0 1px 0 rgb(255 255 255 / 10%);
  }
  .header-company-dropdown {
    display: inline-block;
    position: relative;
    height: 100%;
    margin-right: 15px;

    .dropdown-toggle {
      width: 100%;
      height: 50px;
      text-align: left;
      background-color: transparent;
      border: 0px;
      color: white;
      font-size: 28px;
      font-family: DINNextLTPro-Medium, sans-serif;
      &:focus {
        outline: -webkit-focus-ring-color auto 1px;
        outline-color: -webkit-focus-ring-color;
        outline-style: auto;
        outline-width: 1px;
      }
      span.fullname {
        max-width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 1.3;
        display: inline-block;
        @media(max-width: '1024px') {
          font-size: 24px;
        }
      }
      span.userarea {
        font-family: DINNextLTPro-Regular, sans-serif;
        font-size: 12px;
        opacity: 0.5;
        margin-top: -5px;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      i, .svg-inline--fa:not(.gk-badge-icon) {
        font-size: 18px;
        position: absolute;
        right: -15px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }

  .navbar-nav {
    padding: 10px 0px;
    padding-bottom: 20px;
    .nav-item {
      &.active, &:hover {
        .nav-link, .nav-link > a {
          color: #FFFFFF;
          text-decoration: none;
        }
      }
      .nav-link > a {
        color: rgba(255, 255, 255, 0.7);
      }
      .nav-link,
      .dropdown-menu .dropdown-item {
        outline: 0;
        display: flex;
        align-items: center;
        color: rgba(255, 255, 255, 0.7);
        padding: 7px 17px;
        i, .svg-inline--fa:not(.gk-badge-icon) {
          width: 20px;
          text-align: center;
          font-size: 20px;
          display: block;
          margin-right: 20px;
        }
        span {
          font-size: 14px;
          display: block;
          line-height: 1;
        }
        &:hover, &:focus {
          background: transparent;
          color: #FFFFFF;
        }
      }
    }
  }

  @media(min-width: '768px') {
    .navbar-header {
      display: flex;
    }
    .navbar-nav {
      padding: 0;
      .nav-item {
        .nav-link,
        .dropdown-menu .dropdown-item {
          display: block;
          text-align: center;
          padding: min(20px, 1.75vw);
          padding-top: 7px;
          padding-bottom: 0px;
          i, .svg-inline--fa:not(.gk-badge-icon) {
            margin: 0 auto;
            width: auto;
          }
          span {
            font-size: 12px;
            line-height: 20px;
          }
        }
        .dropdown-menu {
          border: 0;
          margin: 0;
          min-width: auto;
          width: 100%;
          > li {
            margin-top: 5px;
          }
          .dropdown-item {
            padding-left: 5px;
            padding-right: 5px;
          }
        }
      }
    }
  }
}

.ui-dashboard-menu-dropdown.gk-animated-dropdown {
  display: flex;
  align-items: center;
  .gk-animated-dropdown-toggle {
    padding: 0;
    border: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    background: none;
    color: white;
    font-size: 18px;
    width: 40px;
    height: 40px;
    position: relative;
    > i, .svg-inline--fa:not(.gk-badge-icon) { margin: 0; }
    &:hover, &:active {
      background: rgba(0, 0, 0, 0.2);
      color: white;
      &:before {
        box-shadow: 0px 0px 0px 2px darken($colorBrand, 10) !important;
      }
    }
    &:after {
      display: none;
    }
    &.toggle-ai-assistant {
      background: none !important;
      &:hover {
        background: none !important;;
      }
    }
  }
  .gk-animated-dropdown-toggle {
    transition: all 0.15s ease-in-out;
  }

  &.has-notifications {
    .gk-animated-dropdown-toggle {
      &:before {
        content: var(--not-count);
        width: 8px;
        height: 8px;
        position: absolute;
        border-radius: 100%;
        background: $colorAppTrips;
        top: 22px;
        right: 8px;
        z-index: 10;
        box-shadow: 0px 0px 0px 2px $colorBrand;
        transition: inherit;

        height: 12px;
        width: 12px;
        line-height: 12px;
        font-size: 8px;
      }
    }
  }
  .dropdown-menu {
    @media(max-width: '767px') {
      right: 0;
      left: initial;
    }
  }
  &.show {
    .gk-animated-dropdown-toggle {
      color: white;
      background: rgba(0, 0, 0, 0.2);
      &:before {
        box-shadow: 0px 0px 0px 2px darken($colorBrand, 10) !important;
      }
    }
  }
}
</style>
